@if (isLoading$ | async) {
    <app-spinner-loader [showOverlay]="true"></app-spinner-loader>
} @else {
    <app-header></app-header>
    <div class="content">
        <div class="content-width content-padding">
            <router-outlet></router-outlet>
        </div>
    </div>
    <app-footer></app-footer>
}
